import React from 'react';

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

// HttpOnly cookie 只能由 server 清，所以做成 plain HTML form POST，後端
// emit 多 domain 的 Set-Cookie deletes 後 redirect 回 login。CSRF 已在
// controller 端 skip。
//
// 不要把這個入口接到自動 401 redirect — 只能由使用者主動點擊；自動觸發
// 會誤傷 permission-only 401（帳號權限不夠 / 資源權限不足）。
const Form = styled.form`
  text-align: center;
  margin-top: 8px;
`;

const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: rgba(0, 0, 0, 0.65);
  }
`;

interface ClearSessionLinkProps {
  endpoint: string;
}

const ClearSessionLink: React.FC<ClearSessionLinkProps> = ({ endpoint }) => {
  const { t } = useTranslation();

  return (
    <Form action={endpoint} method="POST">
      <LinkButton type="submit">
        {t('common.clear_session.trigger')}
      </LinkButton>
    </Form>
  );
};

export default ClearSessionLink;
